'use client'

import { ChevronRight, FileText } from "lucide-react"
import { resolveColorHex, getVendorPrimaryColor, formatImageURL } from "@/utils/util"
import { getInitials } from "@/utils/avatar"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"

function VendorLogo({ vendor }: { vendor: any }) {
  const primary = resolveColorHex(getVendorPrimaryColor(vendor))
  if (vendor?.logo) {
    return (
      <div className="h-20 w-20 rounded-xl bg-white border border-border p-2 grid place-items-center shrink-0">
        <img src={formatImageURL(vendor.logo)} alt={vendor?.name || ''} className="max-h-full max-w-full object-contain" />
      </div>
    )
  }
  return (
    <div className="h-20 w-20 rounded-xl text-2xl font-semibold text-white grid place-items-center shrink-0" style={{ background: primary }}>
      {getInitials(vendor?.name || 'Shop')}
    </div>
  )
}

export default function About({ vendor }: { vendor?: any }) {
  const pathname = usePathname()
  const primary = resolveColorHex(getVendorPrimaryColor(vendor))
  const vendorName = vendor?.name || 'Дэлгүүр'
  const aboutHtml: string | null = vendor?.about || null

  return (
    <div className="bg-white">
      {/* Hero */}
      <div className="mx-auto w-full max-w-320 px-4 lg:px-8 py-8">
        <div className="flex items-center gap-1.5 text-[12px] text-muted-foreground">
          <a href={navigateUrl('/', pathname)} className="hover:text-foreground">Нүүр</a>
          <ChevronRight className="h-3 w-3" />
          <span className="text-foreground font-medium">Бидний тухай</span>
        </div>

        <div className="mt-8 flex items-center gap-5">
          <VendorLogo vendor={vendor} />
          <div className="min-w-0">
            <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground">{vendorName}</h1>
            {vendor?.description && (
              <div className="text-sm text-muted-foreground mt-2 line-clamp-2 max-w-md">{vendor.description}</div>
            )}
          </div>
        </div>
      </div>

      {/* Body content */}
      <div className="mx-auto w-full max-w-320 px-4 lg:px-8 pt-4">
        <div className="border-t border-border py-8">
          {aboutHtml ? (
            <article
              className="prose mx-auto max-w-3xl text-foreground prose-headings:tracking-[-0.01em] prose-h2:text-[28px] lg:prose-h2:text-[32px] prose-h2:font-bold prose-h2:mt-10 prose-h2:mb-3 prose-h2:pb-3 prose-h2:border-b prose-h2:border-border prose-p:text-[15.5px] prose-p:leading-[1.75] prose-a:underline prose-a:underline-offset-[3px] prose-li:my-1"
              style={{ ['--tw-prose-links' as any]: primary }}
              dangerouslySetInnerHTML={{ __html: aboutHtml }}
            />
          ) : (
            <div className="rounded-2xl border border-dashed border-border p-10 text-center mx-auto max-w-3xl">
              <FileText className="h-10 w-10 text-muted-foreground mx-auto mb-3" />
              <p className="text-sm text-muted-foreground">Одоогоор бидний тухай мэдээлэл нэмэгдээгүй байна.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
